import { assertNever } from 'webui/utils/never';
import { AnalogTemperatureSensor, BoilerAdapter, OTTemperaturePreference, RadioSensor, WiredTemperatureSensor, } from 'z3k-config';
import { ThermometerState } from 'webui/utils/thermometers';
export var RfTypes;
(function (RfTypes) {
    RfTypes["MLT"] = "MLT";
    RfTypes["MLK"] = "MLK";
    RfTypes["MLW"] = "MLW";
    RfTypes["MLM"] = "MLM";
    RfTypes["MLH"] = "MLH";
    RfTypes["_ebr"] = "_ebr";
    RfTypes["_hood"] = "_hood";
    RfTypes["_handsfree"] = "_handsfree";
    RfTypes["_handsfree_bat"] = "_handsfree_bat";
    RfTypes["bt_smartphone"] = "bt_smartphone";
})(RfTypes || (RfTypes = {}));
export function getTemperatureSensor(z3k_config, id) {
    // @ts-ignore
    return (WiredTemperatureSensor.get.byId(z3k_config, id) ??
        AnalogTemperatureSensor.get.byId(z3k_config, id) ??
        RadioSensor.get.byId(z3k_config, id) ??
        BoilerAdapter.get.byId(z3k_config, id));
}
export function get_thermometer_limits(sensor, owa_m) {
    if (!('type' in sensor) && owa_m) {
        return WiredTemperatureSensor.getLimits(sensor, owa_m);
    }
    return { high: null, low: null };
}
export function get_thermometer_state(state, error) {
    if (error === true) {
        return ThermometerState.not_connected;
    }
    if (state) {
        const is_sensor_ok = 'sensor_ok' in state && state.sensor_ok;
        if (is_sensor_ok || error == false) {
            return ThermometerState.ok;
        }
        return ThermometerState.malfunction;
    }
    return ThermometerState.not_connected;
}
export function temperature_from_state(state, ot_preference = OTTemperaturePreference.WATER) {
    if (state == null) {
        return undefined;
    }
    if ('curr_temp' in state) {
        if (state.sensor_ok) {
            return state.curr_temp;
        }
    }
    if ('temperature' in state) {
        if (state.sensor_ok) {
            return state.temperature;
        }
    }
    if ('ot' in state)
        switch (ot_preference) {
            case OTTemperaturePreference.WATER:
                return state.ot.bt;
            case OTTemperaturePreference.DHW:
                return state.ot.dt;
            default:
                return assertNever(ot_preference);
        }
    return undefined;
}
export function get_thermometer_rf(state) {
    if (state) {
        if ('battery' in state && 'rssi' in state) {
            return {
                bat_v: state.battery,
                dbm: state.rssi,
            };
        }
    }
    return undefined;
}
